import Vue from 'vue';
import Router from 'vue-router';
/* AUTH */
import Login from './pages/auth/login/Login.vue';
import LoginExternal from './pages/auth/loginExternal/LoginExternal.vue';
import Register from './pages/auth/register/Register.vue';
import RemindPassword from './pages/auth/remindPassword/RemindPassword.vue';
/* PRIZES */
import Orders from './pages/prizes/orders/Orders.vue';
// Если убрать то стили ломаются
// eslint-disable-next-line no-unused-vars
import Prizes from './pages/prizes/prizes/Prizes.vue';
/* PROFILE */
import Dashboard from './pages/profile/dashboard/Dashboard.vue';
import ProfilePassport from './pages/profile/profilePassport/ProfilePassport.vue';
import ProfileEdit from './pages/profile/profileEdit/ProfileEdit.vue';
import ProfilePurse from './pages/profile/profilePurse/ProfilePurse.vue';
import ProfileBonuses from './pages/profile/profileBonuses/ProfileBonuses.vue';
/* COURSES */
import Courses from './pages/courses/courses/Courses.vue';
import Course from './pages/courses/course/Course.vue';
import Test from './pages/courses/test/Test.vue';
import Results from './pages/courses/result/Results.vue';
/* SALES */
import Sales from './pages/sales/sales/Sales.vue';
import AddSale from './pages/sales/AddSale/form/AddSale.vue';
import AddSaleFns from './pages/sales/AddSaleFns/form/AddSaleFns.vue';
/* NEWS & INSTRUCTIONS */
import News from './pages/news/news/News.vue';
import Publication from './pages/news/publication/Publication.vue';
import Instructions from './pages/news/instructions/Instructions.vue';
import Instruction from './pages/news/instruction/Instruction.vue';
/* TICKETS */
import Tickets from './pages/tickets/tickets/Tickets.vue';
/* NOTIFICATIONS */
import MobileNotifications from './pages/mobileNotifications/MobileNotifications.vue';
/* COMMON */
import Feedback from './pages/feedback/Feedback.vue';
import FAQ from './pages/faq/FAQ.vue';
import NotFound from './pages/NotFound.vue';
import Reset from './pages/Reset.vue';
/* SHOP */
import ShopProduct from './pages/shop/product/Product.vue';
/* CART */
import Cart from './pages/cart/Cart.vue';
/* MARKETS */
import Markets from './pages/markets/Index.vue';
/* PORTFOLIO */
import Portfolio from './pages/portfolio/Portfolio.vue';
/* Seminars */
import Seminars from './pages/seminars/list/Seminars.vue';
/* SPECIALIZATIONS */
import Specializations from './pages/specializations/Specializations.vue';

/* Jobs */
import Jobs from './pages/jobs/list/Jobs.vue';

/* MANAGER CHAT */
import ManagerChat from './pages/managerchat/Index.vue';

/** INFORMATION */
import Information from './pages/information/Information.vue';

/* STATUS */
import Status from './pages/status/Index.vue';

/* APPLICATION */
import Applications from './pages/application/list/Applications.vue';

/* CHAT */
import Chat from './pages/chat/Chat.vue';

/* Promotion */
import Promotion from './pages/promotion/Promotion.vue';

/* DESIGN TMP */
// не удаляйте исходники // хорошо  // спасибо
import technicalPage from './pages/design/technical-page/Index.vue';
import Page1 from './pages/design/page1/Index.vue';
import Page2 from './pages/design/page2/Index.vue';
import Page3 from './pages/design/page3/Index.vue';
import Page4 from './pages/design/page4/Index.vue';
import Page5 from './pages/design/page5/Index.vue';
import Page6 from './pages/design/page6/Index.vue';
import Page7 from './pages/design/page7/Index.vue';
import Page8 from './pages/design/page8/Index.vue';
import Page9 from './pages/design/page9/Index.vue';
import Projecting from './pages/design/projecting/Index.vue';
import ProjectingItem from './pages/design/projectingItem/Index.vue';
import AddSaleTable from './pages/sales/AddSale/table/AddSaleTable.vue';
import AddSaleFnsTable from './pages/sales/AddSaleFns/table/AddSaleFnsTable.vue';
import MainPage from './pages/main-page/Index.vue';

/* GAME */
import GameList from './pages/game/list/GameList.vue';
import Rating from './pages/rating/Rating.vue';
import NotConfirmed from './pages/notconfirmed/NotConfirmed.vue';
import Guarantees from './pages/guarantees/list/Guarantees.vue';

import PolicyPage from './pages/policyPage/PolicyPage.vue';

Vue.use(Router);

const routes = [
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: { requiresGuest: true },
  },
  {
    name: 'login-external',
    path: '/login-external/:id/:token',
    component: LoginExternal,
    props: true,
    meta: { requiresGuest: true },
  },
  {
    name: 'register',
    path: '/register',
    component: Register,
    props: route => ({
      invite_code: route.query.invite_code,
    }),
    meta: { requiresGuest: true },
  },
  {
    name: 'remind',
    path: '/remind',
    component: RemindPassword,
    meta: { requiresGuest: true },
  },
  {
    name: 'orders',
    path: '/orders/:type?',
    component: Orders,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: Dashboard,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'passport',
    path: '/passport',
    component: ProfilePassport,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'profile',
    path: '/profile',
    component: ProfileEdit,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'purse',
    path: '/purse/:type?',
    component: ProfilePurse,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'bonuses',
    path: '/bonuses',
    component: ProfileBonuses,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'courses',
    path: '/courses',
    component: Courses,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'course',
    path: '/course/:id',
    component: Course,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'managerChat',
    path: '/manager-chat',
    component: ManagerChat,
  },
  {
    name: 'test',
    path: '/test/:id',
    component: Test,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'results',
    path: '/results/:id',
    component: Results,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'specializations',
    path: '/specializations',
    component: Specializations,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'jobs',
    path: '/jobs',
    component: Jobs,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'news',
    path: '/news',
    component: News,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'publication',
    path: '/publication/:id',
    component: Publication,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'instructions',
    path: '/instructions',
    component: Instructions,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'instruction',
    path: '/instruction/:id',
    component: Instruction,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'cart',
    path: '/cart',
    component: Cart,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'prizes',
    path: '/prizes',
    component: Prizes,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'shop-product',
    path: '/shop-product/:id',
    component: ShopProduct,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'notifications',
    path: '/notifications',
    component: MobileNotifications,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'tickets',
    path: '/tickets/',
    component: Tickets,
    meta: { requiresAuth: true },
  },
  {
    path: '/actions',
    name: 'actions',
    component: Promotion,
    meta: { requiresAuth: true, approved: true },
  },
  {
    path: '/sales/:type?',
    name: 'sales',
    component: Sales,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    path: '/guarantees',
    name: 'guarantees',
    component: Guarantees,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    path: '/sale/table/:action_id/:id',
    component: AddSaleTable,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    path: '/sale/:action_id/:id',
    component: AddSale,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    path: '/sale-fns/:action_id/:id',
    component: AddSaleFns,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    path: '/sale-fns/table/:action_id/:id',
    component: AddSaleFnsTable,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  { name: 'markets', path: '/markets', component: Markets },
  { name: 'reset', path: '/reset', component: Reset },
  { name: 'feedback', path: '/feedback', component: Feedback },
  { name: 'faq', path: '/faq', component: FAQ },
  {
    name: 'status',
    path: '/status',
    component: Status,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'portfolio',
    path: '/portfolio',
    component: Portfolio,
    meta: { requiresAuth: true },
  },
  {
    name: 'seminars',
    path: '/seminars',
    component: Seminars,
    meta: { requiresAuth: true },
  },
  {
    name: 'information',
    path: '/information',
    component: Information,
    meta: { requiresAuth: true },
  },
  { name: 'applications', path: '/applications', component: Applications },
  { name: '', path: '*', component: NotFound },
  {
    name: 'technicalPage',
    path: '/design/technical-page',
    component: technicalPage,
  },
  {
    name: 'chat',
    path: '/chat/:id',
    component: Chat,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  {
    name: 'promotion',
    path: '/promotion/',
    component: Promotion,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  { name: 'page1', path: '/design/page1', component: Page1 },
  { name: 'page2', path: '/design/page2', component: Page2 },
  { name: 'page3', path: '/design/page3', component: Page3 },
  { name: 'page4', path: '/design/page4', component: Page4 },
  { name: 'page5', path: '/design/page5', component: Page5 },
  { name: 'page6', path: '/design/page6', component: Page6 },
  { name: 'page7', path: '/design/page7', component: Page7 },
  { name: 'page8', path: '/design/page8', component: Page8 },
  { name: 'page9', path: '/design/page9', component: Page9 },
  { name: 'projecting', path: '/design/projecting', component: Projecting },
  {
    name: 'projectingItem',
    path: '/design/projecting-item/:id/:tab/',
    component: ProjectingItem,
    props: true,
    meta: { requiresAuth: true, approved: true },
  },
  { name: 'main', path: '/', component: MainPage, meta: { requiresAuth: true, approved: false } },
  { name: 'notConfirmed', path: '/notConfirmed', component: NotConfirmed },
  { path: '/games', name: 'games', component: GameList, meta: { requiresAuth: true } },
  { path: '/rating', name: 'rating', component: Rating, meta: { requiresAuth: true } },
  { name: 'policyPage', path: '/policy-page', component: PolicyPage },
];

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach(async (to, from, next) => {
  Vue.notify({ group: 'error', clean: true });
  const { requiresGuest, requiresAuth, approved } = to.meta;
  let isAuthenticated = false;
  let isBlocked = true;
  const storage = localStorage.getItem('promo');
  let user = null;
  if (storage !== null) {
    const parsedStorage = JSON.parse(storage);
    const { token } = parsedStorage;
    // eslint-disable-next-line prefer-destructuring
    user = parsedStorage.user;
    const { profileLoaded } = parsedStorage;
    if (!profileLoaded) {
      await router.app.$nextTick();
      await router.app.$store.dispatch('GetProfile');
      // eslint-disable-next-line prefer-destructuring
      user = router.app.$store.state.user;
    }
    if (token !== undefined && token !== null) {
      isAuthenticated = true;
    }
    if (isAuthenticated && user && user.blocked_at === null) {
      isBlocked = false;
    }
  }
  if (requiresGuest && isAuthenticated) {
    next('/dashboard');
  } else {
    next();
  }

  if (isAuthenticated && isBlocked && approved) {
    next('/dashboard');
  } else {
    next();
  }

  const userIsApproved = user && !!user.is_checked;
  if (to.name === 'notConfirmed' && user?.is_checked) {
    next('/dashboard');
    return;
  }
  if ((requiresAuth && !isAuthenticated) || (approved && !userIsApproved)) {
    if (user && !user.is_checked) {
      next({ name: 'notConfirmed' });
    } else {
      next('/');
    }
  } else {
    next();
  }
});

export default router;
